export default __webpack_public_path__ + "static/fa-regular-400-f7c04b6521c52b1ef3e3782f22473d43.svg";